import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Tab,
  Tabs,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Autocomplete,
  InputAdornment,
  IconButton,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Menu,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  TableFooter,
} from "@mui/material";
import ListIcon from '@mui/icons-material/List';
import InfoIcon from '@mui/icons-material/Info';
import RefreshIcon from "@mui/icons-material/Refresh";
import CloseIcon from '@mui/icons-material/Close';
import CancelIcon from '@mui/icons-material/Cancel';
import SearchIcon from '@mui/icons-material/Search';
//import { IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ClearIcon from '@mui/icons-material/Clear';
import AddIcon from '@mui/icons-material/Add';
import VisibilityIcon from '@mui/icons-material/Visibility';
import GetAppIcon from '@mui/icons-material/GetApp';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import TableChartIcon from '@mui/icons-material/TableChart';
import ArticleIcon from '@mui/icons-material/Article';
import DescriptionIcon from '@mui/icons-material/Description';
// import {
import { Controller, SubmitHandler, useForm, Watch } from "react-hook-form";
import axios from "axios";
import { IBonDeCaisse, ICompte, ISimulationBDC2 } from "../../../dataTypes/GlobalDataType";
import { Crypter } from "../../../Functions/Security/Crypter";
import Data from '../../../Data/Data.json';
import { useAuthHeader, useAuthUser } from "../../../Services/Auth/sessionAuth";
import Utilisateur from "../../../Models/Utilisateur";
import { fetchDataTable2, formatDate, GlobalExportToCSV, GlobalExportToExcel, GlobalExportToJSON, GlobalExportToPDF, GlobalExportToWord } from "../../../utilitaires/globalFunction";
import formatNumber from "../../../Functions/Traitement/FormatNumber";
import SweetAlert from "sweetalert2";
import Swal from "sweetalert2";   
import withReactContent from "sweetalert2-react-content";
import SaveIcon from '@mui/icons-material/Save';
import UpdateIcon from '@mui/icons-material/Update';
import { init } from "i18next";
import DataType from "../../../Types/DataTablePiclist";
import DoneIcon from '@mui/icons-material/Done';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import BlockIcon from '@mui/icons-material/Block';
import { Filter } from "@mui/icons-material";
//import DescriptionIcon from "@mui/icons-material/Description";

//import CancelIcon from '@mui/icons-material/Cancel';

export default function AnticipationBDC() {
     const auth = useAuthUser()
         
          const authHeader = useAuthHeader()
      
  const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))
  const [tab, setTab] = useState(0);
  const [data, setData] = useState<IBonDeCaisse[]>([]);
  const [selected, setSelected] = useState<IBonDeCaisse | null>(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(0); // Page actuelle
  const [rowsPerPage, setRowsPerPage] = useState(5); // Tu peux ajuster le nombre par défaut ici
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [anchorElInt, setAnchorElInt] = useState<null | HTMLElement>(null);
  const [simulations, setSimulations] = useState<ISimulationBDC2[]>([]);

  const [tauxPenal, setTauxPenal] = useState(0);
  const [montPenal, setMontPenal] = useState(0);
  const [jrRest, setJrRest] = useState(0);
  const [intDu, setIntDu] = useState(0);
  const [intAquis, setIntAquis] = useState(0);
  const [compte, setCompte] = useState<ICompte []>([]);
  const [selectedCpt, seSelectedCpt] = useState<ICompte []>([]);
  const [activ, setActiv] = useState(true); // Page actuelle

  const [openDialog, setOpenDialog] = useState(false);
  const [codOpe, setCodOpe] = useState('');
   const [libOpe, setLibOpe] = useState('');

   
  //const [resultat, setResultat] = useState<any>(null);

// const [echeancier, setEcheancier] = useState<
//   { periode: number; dateImput: string;  interet: number; taxe: number; netAPayer: number }[]
// >([]);
const [echeancier, setEcheancier] = useState<{
  periode: number;
  dateImput: string;
  interet: number;
  taxe: number;
  netAPayer: number;
}[]>([]);

 const [resultat, setResultat] = useState({
  montInt: 0,
  montTaxe: 0,
  montNet: 0,
 // echeancier: [],
});  
const totalInteret = echeancier.reduce((acc, row) => acc + row.interet, 0);
const totalTaxe = echeancier.reduce((acc, row) => acc + row.taxe, 0);
const totalNet = echeancier.reduce((acc, row) => acc + row.netAPayer, 0);
 
  const { register, handleSubmit, reset,setValue, control,watch } = useForm<IBonDeCaisse>({
  defaultValues: {
  IDBDC: 0,
  NUMBDC: "",
  REFBDC: "",
  CODSIMUL: "",
  NUMCLI: "",
  NOMCLI: "",
  TYPBDC: "",
  TYPIMPUTINT: "",
  FREQPROV: "",
  DUREE: "",
  MONTANT: "",
  TXINT: "",
  MTNINT: "",
  MTNNETAPAYER: "",
  TXTAXE: "",
  MTNTAXE: "",
  MTNPROVFREQ: "",
  MTNTAXEFREQ: "",
  // DATDEBUT:  new Date(Perss.datjour).toISOString(),
  // DATFIN: new Date(Perss.datjour).toISOString(),
  DATDEBUT: new Date(Perss.datjour).toISOString().substring(0, 10),
  DATFIN: new Date(Perss.datjour).toISOString().substring(0, 10),
  CODOPE: "",
  LIBOPE:"",
  CPTDEPOT: "",
  CPTBDC: "",
  CPTINTCLI: "",
  CPTINT: "",
  CPTPROV: "",
  CPTTAXE: "",
  CPTTAXEDEB: "",
  CPTTAXECRE: "",
  CDETAT: "",
  CODAGE: Perss.codage,
  DATCRE: new Date(Perss.datjour),
  UTISAI: Perss.coduti,
  UTIVAL: "",
  DATVAL: new Date(Perss.datjour),
  HEUREVAL: new Date().toISOString(),
  DISPONCPTDEPOT: "",
  DISPONCPTBDC: "",
  DISPONCPTINT: ""
 // DATINTERUPT: ""
  },
});

 const cptDepot = watch("CPTDEPOT");
 const cptBDC = watch("CPTBDC");
 const cptIntCli = watch("CPTINTCLI");

const viderFormulaire = () => {
  reset({
    IDBDC: 0,
    NUMBDC: "",
    REFBDC: "",
    CODSIMUL: "",
    NUMCLI: "",
    NOMCLI: "",
    TYPBDC: "",
    TYPIMPUTINT: "",
    FREQPROV: "",
    DUREE: "",
    MONTANT: "",
    TXINT: "",
    MTNINT: "",
    MTNNETAPAYER: "",
    TXTAXE: "",
    MTNTAXE: "",
    MTNPROVFREQ: "",
    MTNTAXEFREQ: "",
    DATDEBUT: "",
    DATFIN: "",
    CODOPE: "",
    CPTDEPOT: "",
    CPTBDC: "",
    CPTINTCLI: "",
    CPTINT: "",
    CPTPROV: "",
    CPTTAXE: "",
    CPTTAXEDEB: "",
    CPTTAXECRE: "",
    CDETAT: "01",
    CODAGE: Perss.codage,
    DATCRE: new Date(Perss.datjour),
    UTISAI: Perss.coduti,
    UTIVAL: "",
    DATVAL: new Date(Perss.datjour),
    HEUREVAL: "",
    DISPONCPTDEPOT: "",
    DISPONCPTBDC: "",
    DISPONCPTINT: "",
    DATINTERUP:new Date(Perss.datjour),
    INTACQUIS:0,
    INTDUS:0,
    JOURRESTANT:0,
    PENALITE:0
  });
  setMontPenal(0)
  setJrRest(0)
  setIntAquis(0)
  setIntDu(0)
};

  const api = Data.ApiUrl.BdcBase;
const MySwal = withReactContent(Swal);
  // Charger la liste
  const  fetchData = async (int:string) => {
      try {
               // console.log(apiEndpoints.bureaux)
               if (int=="")
               {
                var params = { CodeAgence: Perss.codage , Table: "BONDECAISSE", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: "CODAGE", Init: "", choix: 32, colfiltre: "", valfiltre: "" }
       
               }else {
               // alert(searchTerm)
                   var params = { CodeAgence: "" , Table: "BONDECAISSE", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: "", Init: searchTerm, choix: 37, colfiltre: "CODAGE", valfiltre: Perss.codage }
    
               }
          
                const res = await fetchDataTable2(Data.ApiUrl.AnySearch, params, authHeader());
                 const data: IBonDeCaisse[] = res//res.data?.Result?.Table || [];
                //console.log(res)
               if (res.length!==0)
                   {       
                      const filtered = data.filter(c =>
                             c.CDETAT?.toLocaleUpperCase().includes("02") 
                                   );
                     setData(filtered);
                     console.log("✅ Simulations chargées :", filtered);
              
                   }else{ console.warn("Aucune donnée reçue !");}
                }catch (err) {
                console.error("Erreur de chargement:", err);
               // setError("Impossible de charger les données .");
               } finally {
                //setLoading2(false);
                return []
               }
        
      //   const res = await axios.get(API_URL);
      //   return res.data;
   // const res = await axios.get(api);
  //  setData(res.data);
  };

   const fetchDataCodOpe = async (inite:string) => {
      try {
               // console.log(apiEndpoints.bureaux)
              
                var params = { CodeAgence:"" , Table: "OPERAT", Colonne1: "CODOPE", Colonne2: "LIBELL", Colagence: "", Init: "", choix: 22, colfiltre: "CODOPE", valfiltre: inite }
          
                const res = await fetchDataTable2(Data.ApiUrl.AnySearch, params, authHeader());
                 const data=res// res.data?.Result?.Table || [];
                //console.log(res)
               if (res.length!==0)
                   { 
                     setValue("CODOPE",data[0]?.CODOPE ?? "")
                     setValue("LIBOPE",data[0]?.LIBELL ?? "")

                   //  console.log("✅ Simulations chargées :", data);
              
                   }else{ console.warn("Aucune donnée reçue !");}
                }catch (err) {
                console.error("Erreur de chargement:", err);
               // setError("Impossible de charger les données .");
               } finally {
                //setLoading2(false);
                return []
               }
        
      //   const res = await axios.get(API_URL);
      //   return res.data;
   // const res = await axios.get(api);
  //  setData(res.data);
  };
  
  
  // 🔹 Ouvre le menu
    const handleClickExport = (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
    };
    // 🔹 Ouvre le menu
    const handleClickExportInt = (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorElInt(event.currentTarget);
    };
   // 🔹 Fonctions d’exportation (à implémenter selon ton besoin)
    const handleExport = (format: any) => {
      handleCloseExport();
      switch (format) {
        case 'excel':
         // console.log('Export Excel', data);
          GlobalExportToExcel(paginatedDataBranch,"Exportation bon de caisse","BonDeCaisse")
          // Appeler ici ta fonction d’export Excel
          break;
        case 'pdf':
          //console.log('Export PDF', data);
          // Appeler ici ta fonction d’export PDF
          GlobalExportToPDF(paginatedDataBranch,"Exportation bon de caisse ","BonDeCaisse")
          break;
           case 'word':
          //console.log('Export PDF', data);
          // Appeler ici ta fonction d’export PDF
          GlobalExportToWord(paginatedDataBranch,"Exportation bon de caisse ","TableauInteretsBDC")
          break;
        case 'csv':
         // console.log('Export CSV', data);
          // Appeler ici ta fonction d’export CSV
         GlobalExportToCSV(paginatedDataBranch,"Exportation bon de caisse ","BonDeCaisse") 
          break;
        case 'json':
         // console.log('Export JSON', data);
          // Appeler ici ta fonction d’export JSON
          GlobalExportToJSON(paginatedDataBranch,"Exportation bon de caisse ","BonDeCaisse") 
          break;
        default:
          break;
      }
    };

    const handleExportInt = (format: any) => {
      handleCloseExportInt();
      switch (format) {
        case 'excel':
         // console.log('Export Excel', data);
          GlobalExportToExcel(echeancier,"Exportation tableau imputaion interets "+selected?.NUMBDC+"-"+selected?.NOMCLI,"TableauInteretsBDC")
          // Appeler ici ta fonction d’export Excel
          break;
        case 'pdf':
          //console.log('Export PDF', data);
          // Appeler ici ta fonction d’export PDF
          GlobalExportToPDF(echeancier,"Exportation tableau imputaion interets "+selected?.NUMBDC+"-"+selected?.NOMCLI,"TableauInteretsBDC")
          break;
           case 'word':
          //console.log('Export PDF', data);
          // Appeler ici ta fonction d’export PDF
          GlobalExportToWord(echeancier,"Exportation tableau imputaion interets "+selected?.NUMBDC+"-"+selected?.NOMCLI,"TableauInteretsBDC")
          break;
        case 'csv':
         // console.log('Export CSV', data);
          // Appeler ici ta fonction d’export CSV
         GlobalExportToCSV(echeancier,"Exportation tableau imputaion interets "+selected?.NUMBDC+"-"+selected?.NOMCLI,"TableauInteretsBDC") 
          break;
        case 'json':
         // console.log('Export JSON', data);
          // Appeler ici ta fonction d’export JSON
          GlobalExportToJSON(echeancier,"Exportation tableau imputaion interets "+selected?.NUMBDC+"-"+selected?.NOMCLI,"TableauInteretsBDC") 
          break;
        default:
          break;
      }
    };
    // 🔹 Ferme le menu
  const handleCloseExport = () => {
    setAnchorEl(null);
  };
  

  const handleCloseExportInt = () => {
    setAnchorElInt(null);
  };
  
    const getSimulations = async (int:string) => {
     
         try {
             // console.log(apiEndpoints.bureaux)
             if (int=="")
             {
              var params = { CodeAgence: Perss.codage , Table: "SIMULATIONBDC", Colonne1: "CODBDC", Colonne2: "LIBELL", Colagence: "CODAGE", Init: "", choix: 32, colfiltre: "", valfiltre: "" }
     
             }else {
              alert(searchTerm)
                 var params = { CodeAgence: "" , Table: "SIMULATIONBDC", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: "", Init: searchTerm, choix: 37, colfiltre: "CODAGE", valfiltre: Perss.codage }
  
             }
        
              const res = await fetchDataTable2(Data.ApiUrl.AnySearch, params, authHeader());
               const data: ISimulationBDC2[] = res//res.data?.Result?.Table || [];
              //console.log(res)
             if (res.length!==0)
                 { 
                   const filtered = data.filter(c =>
                             c.CDETAT?.toLocaleUpperCase().includes("01") || c.CDETAT?.toLocaleUpperCase().includes("") || c.CDETAT?.toLocaleUpperCase().includes("NULL")
                                   );
                   //console.log(filtered)
                  // setCompte(filtered);      
                   setSimulations(filtered);
                   console.log("✅ Simulations chargées :", filtered);
            
                 }else{ console.warn("Aucune donnée reçue !");}
              }catch (err) {
              console.error("Erreur de chargement:", err);
             // setError("Impossible de charger les données .");
             } finally {
              //setLoading2(false);
              return []
             }
      
    //   const res = await axios.get(API_URL);
    //   return res.data;
    };

     const getTauxPenalite = async (cod:string) => {
      interface IResult {
        TXPENALITE: number;
        CODBDC: string;
        }
     
         try {
            
              var params = { CodeAgence: Perss.codage , Table: "PARAMBDC", Colonne1: "CODBDC", Colonne2: "TXPENALITE", Colagence: "CODAGE", Init: "", choix: 22, colfiltre: "CODBDC", valfiltre: cod }
     
              const res = await fetchDataTable2(Data.ApiUrl.AnySearch, params, authHeader());
               const data:  IResult[] = res//res.data?.Result?.Table || [];
              console.log(data)
             if (res.length!==0)
                 { 
               const taux = Number(data[0].TXPENALITE);
                setTauxPenal(taux);
                
                 }else{ console.warn("Aucune donnée reçue !");}
              }catch (err) {
              console.error("Erreur de chargement:", err);
             // setError("Impossible de charger les données .");
             } finally {
              //setLoading2(false);
              return []
             }
      
    //   const res = await axios.get(API_URL);
    //   return res.data;
    };
    const getComptes = async (int:string) => {
        setCompte([])
       // setValue("DISPONCPTDEPOT", '0');
         try {
             // console.log(apiEndpoints.bureaux)
             if (int=="")
             {
              var params = { CodeAgence: Perss.codage , Table: "COMPTES", Colonne1: "NUMCLI", Colonne2: "NOMCPT", Colagence: "AGCCPT", Init: int, choix: 34}
     
             }else {
                var params = { CodeAgence: Perss.codage , Table: "COMPTES", Colonne1: "NUMCLI", Colonne2: "NOMCPT", Colagence: "AGCCPT", Init: int, choix: 34}
 
             }
        
              const res = await fetchDataTable2(Data.ApiUrl.AnySearch, params, authHeader());
               const data: ICompte[] = res//res.data?.Result?.Table || [];
              //console.log(res)
             if (res.length!==0)
                 {  
                    console.log(data)     
                    const filtered = data.filter(c =>
                             c.categocpt?.toLocaleUpperCase().includes("D")  || c.categocpt?.toLocaleUpperCase().includes("P")
                                   );
                   console.log(filtered)
                   setCompte(filtered);
                   
                   //console.log("✅ Simulations chargées :", data);
            
                 }else{ console.warn("Aucune donnée reçue !");}
              }catch (err) {
              console.error("Erreur de chargement:", err);
             // setError("Impossible de charger les données .");
             } finally {
              //setLoading2(false);
              return []
             }
      
    //   const res = await axios.get(API_URL);
    //   return res.data;
    };

     function calculer(row: IBonDeCaisse) {
      setSelected(row);
      const prochaineDate = new Date(row.DATDEBUT  || Perss.datjour);
      
    
      const freq = (row.FREQPROV || "").toUpperCase();
      const montant = Number(row.MONTANT) || 0;
      const tauxInteret = Number(row.TXINT) || 0;
      const tauxTaxe = Number(row.TXTAXE) || 0;
      const duree = Number(row.DUREE) || 0; 
    
    
      // 🔹 2. Déterminer la durée en jours selon la fréquence
      let jours = 0;
      switch (freq) {
        case "A": jours = 360; break;   // Annuel
        case "S": jours = 180; break;   // Semestriel
        case "T": jours = 90; break;    // Trimestriel
        case "M": jours = 30; break;    // Mensuel
        case "B": jours = 15; break;    // Bimensuel
        case "F": jours = 60; break;    // Bimestriel
        case "H": jours = 7; break;     // Hebdomadaire
        case "J": jours = 1; break;     // Journalier
        default: jours = 30;            // Valeur par défaut
      }
    
      
        prochaineDate.setDate(prochaineDate.getDate() + jours * duree);
      
      
        //form.setFieldValue("DATFIN", prochaineDate.toISOString().split("T")[0]);
       // alert(form.getFieldValue("DATFIN"))
      // // 🔹 3. Calculs financiers
      // const montInt = (montant * tauxInteret * duree * jours) / 36000; // intérêt brut
      // const montTaxe = (montInt * tauxTaxe) / 100;                      // taxe totale
      // const montNet = montInt - montTaxe;                               // net à percevoir
      // const montTaxeFreq = montTaxe / duree;                            // taxe par période
      // const montProvFreq = montInt / duree;                             // provision par période
     
          // 1️⃣ Calcul brut de l'intérêt
let montIntBrut = (montant * tauxInteret * duree * jours) / 36000;

// 2️⃣ Calcul provisoire de l'intérêt par période (avant recalage)
let montProvFreq = Math.round(montIntBrut / duree);

// 3️⃣ Recalage de l'intérêt total
let montInt = montProvFreq * duree;

// 4️⃣ Calcul brut de la taxe (avant arrondis)
let montTaxeBrut = (montInt * tauxTaxe) / 100;

// 5️⃣ Calcul provisoire de la taxe périodique
let montTaxeFreq = Math.round(montTaxeBrut / duree);

// 6️⃣ Recalage de la taxe totale
let montTaxe = montTaxeFreq * duree;

// 7️⃣ Net perçu
let montNet = montInt - montTaxe;

      // 🔹 4. Calcul de la date de fin
      const dateFin = new Date(prochaineDate);
      dateFin.setDate(prochaineDate.getDate() + jours * duree);
    
      // 🔹 5. Génération du tableau d’échéances
      //const echeancier = [];
      //let dateEcheance = new Date(prochaineDate);
      let dateEcheance = new Date(row.DATDEBUT|| Perss.datjour);
     // const echeancier: any[] = []; // 🔥 reset obligatoire à chaque calcul
      const newEcheancier = [];
      for (let i = 1; i <= duree; i++) {
        const prochaine = new Date(dateEcheance);
        prochaine.setDate(prochaine.getDate() + jours);
    
        newEcheancier.push({
          periode: i,
          dateImput: dateEcheance.toLocaleDateString(),
          //dateFin: prochaine.toLocaleDateString(),
          interet: montProvFreq,
          taxe: montTaxeFreq,
          netAPayer: montProvFreq - montTaxeFreq,
        });
    
        dateEcheance = prochaine;
      }
     
      // // 🔹 6. (optionnel) Notification
      // Swal.fire({
      //   icon: "info",
      //   title: "Calcul terminé",
      //   html: `
      //     <p><b>Intérêt brut :</b> ${montInt.toFixed(2)}</p>
      //     <p><b>Taxe :</b> ${montTaxe.toFixed(2)}</p>
      //     <p><b>Net à percevoir :</b> ${montNet.toFixed(2)}</p>
      //   `,
      // });

  setResultat({
  montInt,
  montTaxe,
  montNet,
 // newEcheancier,
});
setEcheancier(newEcheancier);
setOpenDialog(true);
      // setCal(true)
    }
  function calculInterruptionBDC(nbJr:number) {

  const d1 = new Date(watch('DATDEBUT'));
  const d2 = new Date(watch('DATFIN'));
  const dInt = new Date(watch('DATINTERUP'));
  const int=watch('MTNNETAPAYER')
  
  const joursEcoules = Math.round( (dInt.getTime() - d1.getTime()) / (1000 * 3600 * 24));
  let joursRestants = Math.round( (d2.getTime() - dInt.getTime()) / (1000 * 3600 * 24));
  if (nbJr!=0 && nbJr!=joursRestants)  {joursRestants=nbJr}
  const interetAcquis = Math.round(( Number(watch('MONTANT'))  * Number(watch('TXINT' )) * joursEcoules) / 36000);
  const penalite = Math.round((Number(watch('MONTANT')) * tauxPenal * joursRestants) / 36000);

  console.log(penalite)
  //console.log(joursRestants)
  //console.log(d2.getTime())

  setJrRest(joursRestants)
  setMontPenal(penalite)
  //console.log(penalite)
  setIntAquis(interetAcquis)
  setIntDu(Number(int) -Number(interetAcquis))
  

//   return {
//     montant,
//     interetAcquis,
//     penalite,
//     total: montant + interetAcquis + penalite
//   };
}  
  
  // 📄 Filtrage des données en fonction du terme de recherche
    const filteredDataBranch = data.filter((item) =>
      Object.values(item).some(val =>
        String(val).toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
    // 📄 Pagination après filtrage
    const paginatedDataBranch = filteredDataBranch.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );
  
    // 🔁 Gestion du changement de page
    const handleChangePage = (event: unknown, newPage: number) => {
      setPage(newPage);
    };
  
    // 🔁 Gestion du changement de nombre de lignes
    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0); // Revenir à la première page après changement
    };

  useEffect(() => {
    fetchData("");
    fetchDataCodOpe("990")
    getSimulations("")
    setActiv(false)
  }, []);

 

  useEffect(() => {
  if (cptDepot) {
    const cpt = compte.find(x => x.NUMCPT === cptDepot);
    if (cpt) {
      setValue("DISPONCPTDEPOT", formatNumber(cpt.DISPON), { shouldDirty: true });
    }else{setValue("DISPONCPTDEPOT", formatNumber(0), { shouldDirty: true });}
  }
   
}, [cptDepot, compte]);

 useEffect(() => {
  
   if (cptBDC) {
    const cpt = compte.find(x => x.NUMCPT === cptBDC);
    if (cpt) {
      setValue("DISPONCPTBDC", formatNumber(cpt.DISPON), { shouldDirty: true });
    }else{setValue("DISPONCPTBDC", formatNumber(0), { shouldDirty: true });}
  }

  
}, [cptBDC, compte]);

useEffect(() => {
  
  
  if (cptIntCli) {
    const cpt = compte.find(x => x.NUMCPT === cptIntCli);
    if (cpt) {
      setValue("DISPONCPTINT", formatNumber(cpt.DISPON), { shouldDirty: true });
    }else{setValue("DISPONCPTINT", formatNumber(0), { shouldDirty: true });}
  }
}, [cptIntCli, compte]);

//   const onSubmit = async (values: IBonDeCaisse) => {
//const onSubmit: SubmitHandler<IBonDeCaisse> = async (values) => {
const onSubmit = async (values: any) => {       
            values.CPTDEPOT= cptDepot
            values.CPTBDC=cptBDC
            values.CPTINTCLI=cptIntCli
            values.PENALITE= montPenal
            values.INTACQUIS= intAquis
            values.INTDUS= intDu
           // alert(intDu)

                if (values.CDETAT!='02')
                  {
                    Swal.fire({
                    icon: "warning",
                    title: "Validation simulation",
                    text: "Impossible d'anticiper ce bon de caisse: il n'a pas été validé ou retjeté",
                    target: document.body, // ✅ Rend le popup au-dessus du Dialog
                    backdrop: true,
                    });
                    return;
                  }
                        const result = await MySwal.fire({
                        title: selected ? "Anticipation du bon de caisse" : "Anticipation  bon de caisse",
                        text: `Voulez-vous ${selected ? "anticiper" : "créer"} le bon de caisse : ${values.REFBDC} ?`,
                        showCancelButton: true,
                        confirmButtonText: "Oui",
                        cancelButtonText: "Non",
                        icon: "question",
                        confirmButtonColor: "green",
                        cancelButtonColor: "darkred",
                        customClass: {
                            popup: "swal-front",
                        },
                        target: document.body, // ✅ garantit que le popup est dans le body
                        });
                        if (result.isConfirmed) {
                            //setLoading(true);
                            //setIsSubmit(true)
        
                            let data = Crypter.encrypt(JSON.stringify(values));
                            let config = {
                                method: 'put',
                                maxBodyLength: Infinity,
                                url: Data.ApiUrl.AnticiperBonDeCaisse,
                                headers: {
                                    'CypherBonDeCaisse': data,
                                    'Authorization': authHeader(),
                                    'Content-Type': 'application/json'
                                },
                                data: data
                            };
        
                            axios.request(config)
                                .then((response) => {
                                   // setLoading(false);
                                    if (response.data) {
                                        const res = JSON.parse(Crypter.decrypt(response.data));
                                        //console.log(res)
                                        if (res.StatutCode == 200) {
                                            let code = res.Result
        
                                            if (code == 'INCONNU') {
                                                SweetAlert.fire({ title: res.Message, text: "Ce code n'existe pas", icon: "warning" })
                                            } else {
        
                                                SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                                            }
                                          
                                        }
                                        else {
                                            SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                        }
                                    }
                                })
                                .catch((error) => {
                                 //   setLoading(false);
                                    console.log(error)
                                    SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                                });
                        }

    fetchData("");
    // reset();
    viderFormulaire();
    setSelected(null);
    setTab(0);
    setActiv(true)
    setCompte([])
  };

  const handleEdit = (row: any) => {
    //viderFormulaire();
    //alert(row.DATDEBUT) 
     const cleanRow = {
    ...row,
    DATDEBUT: row.DATDEBUT ? new Date(row.DATDEBUT).toISOString().substring(0,10) : "",
    DATFIN: row.DATFIN ? new Date(row.DATFIN).toISOString().substring(0,10) : "",
    DATINTERUP: Perss.datjour
    
    
  };
  fetchDataCodOpe("990")
  setSelected(cleanRow);
  reset(cleanRow);
    // setSelected(row);
    // reset(row);
    setTab(1);
    setActiv(true)
    getComptes(row.NUMCLI)
    
  };

  const handleDelete = async (id: number) => {
    if (window.confirm("Confirmer la suppression ?")) {
      await axios.delete(`${api}/${id}`);
      fetchData("");
    }
  };

  const handleNew = () => {
    //reset();
     viderFormulaire();
    setSelected(null);
    setTab(1);
    setActiv(true)
    setCompte([])
  };

  return (
   
 <Box mt={3} ml={2} mr={2}  fontStyle="inherit" className='border' width={"85%"} position={"absolute"}  sx={{p:1, height: 'auto',overflowY: 'visible'}}>
             <Box mb={2}>
                {/* <h3>Liste des simulations bon de caisse</h3> */}
                 <legend style={{ fontSize: '1.5rem' }} > Anticipation bons de caisse</legend>
              </Box>

        <Tabs
            value={tab}
            onChange={(_, v) => setTab(v)}
             
               
            sx={{
              borderBottom: "1px solid black",
              mb: 2,
           
              "& .MuiTab-root": {
                border: "1px solid white",
                borderRadius: "5px 5px 0 0",
                marginRight: 1,
                backgroundColor: "transparent",
                color: "black", // <-- inactif = noir
                fontWeight: "bold",
                textTransform: "none",
                transition: "all 0.3s ease",
                minHeight: 35,
                "&:hover": {
                  color: "primary",
                  cursor: "pointer",
                },
                "&.Mui-selected": {
                  color: "white",     // <-- actif = blanc
                  backgroundColor: "#008040",
                },
              },
            }}
          >
      <Tab label="Liste des BDC" icon={<ListIcon />} iconPosition="start" />
      <Tab
        label={selected ? "Détail BDC" : "Détail BDC"}
        icon={<Filter />}
        iconPosition="start"
      />
        </Tabs>


      {tab === 0 && (
        <Box   sx={{ p:1,  borderRadius: 3, background:'white'}}>
             <Box  mb={3} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            {/* Groupe de boutons à gauche */}
            <Box sx={{ display: "flex", gap: "10px" }}>
              {/* <Button
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
                onClick={handleNew}
                 sx={{ borderRadius: 2, fontWeight: 'bold' }}
              >
                Ajouter
              </Button> */}
             
              <Button
                variant="contained"
                color="primary"
                startIcon={<VisibilityIcon />}
                onClick={() => fetchData(searchTerm)}
                 sx={{ borderRadius: 2, fontWeight: 'bold' }}
              >
                Consulter
              </Button>

               <Button
                variant="contained"
                color="primary"
                startIcon={<RefreshIcon />}
                onClick={() => fetchData("")}
                 sx={{  borderRadius: 2, fontWeight: 'bold' }}
              >
                Actualiser
              </Button>
            </Box>
          
            {/* Bouton Exporter à droite */}
            <Button
              variant="contained"
              color="success"
              startIcon={<GetAppIcon />}
              onClick={handleClickExport}
              
              sx={{ borderRadius: 2, fontWeight: 'bold' }}
            >
              Exporter
            </Button>
          
            {/* Menu pour les formats d'exportation */}
            <Menu
              anchorEl={anchorEl}
              // open={open1}
               open={Boolean(anchorEl)}    // ouvert si anchorEl != null
              onClose={handleCloseExport}
               anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
          
              PaperProps={{
                sx: {
                  borderRadius: 3,
                  mt: 1,
                  minWidth: 180,
                },
              }}
               
            >
              <MenuItem onClick={() => handleExport('excel')}>
                <ListItemIcon><TableChartIcon color="primary" /></ListItemIcon>
                <ListItemText>Excel (.xlsx)</ListItemText>
              </MenuItem>
              <MenuItem onClick={() => handleExport('pdf')}>
                <ListItemIcon><PictureAsPdfIcon color="error" /></ListItemIcon>
                <ListItemText>PDF (.pdf)</ListItemText>
              </MenuItem>
              <MenuItem onClick={() => handleExport('word')}>
               <DescriptionIcon sx={{ color: "#2B579A" }} /> {/* Bleu Word */}
                <ListItemText>Word (.docx)</ListItemText>
              </MenuItem>
              <MenuItem onClick={() => handleExport('csv')}>
                <ListItemIcon><ArticleIcon color="info" /></ListItemIcon>
                <ListItemText>CSV (.csv)</ListItemText>
              </MenuItem>
              <MenuItem onClick={() => handleExport('json')}>
                <ListItemIcon><DescriptionIcon color="secondary" /></ListItemIcon>
                <ListItemText>JSON (.json)</ListItemText>
              </MenuItem>
            </Menu>
          </Box>
             
           
            {/* Zone de recherche */}
                                                       
               <Box sx={{ mb: 2 }}>
                <TextField
                  label="Recherche"
                  variant="outlined"
                  fullWidth
                  size="small"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  InputLabelProps={{
                    sx: {
                      fontWeight: 'bold',
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {/* Icône cliquable */}
                        <IconButton onClick={(e) =>getSimulations(searchTerm)} edge="end">
                          <SearchIcon color="primary" />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
          {/* <Button
            variant="contained"
            color="primary"
            onClick={handleNew}
            sx={{ mb: 2 }}
          >
            Nouveau BDC
          </Button> */}
          <TableContainer component={Paper}
          elevation={3} sx={{
                        // --- Styles pour les ascenseurs ---
                        maxHeight: 'auto', // Hauteur maximale pour l'ascenseur vertical (ajustez selon besoin)
                        overflowY: 'auto', // Active l'ascenseur vertical si le contenu dépasse
                        overflowX: 'auto', // Active l'ascenseur horizontal si le contenu dépasse
                        width: '100%', // S'assure que le conteneur prend toute la largeur disponible
                        minWidth: '900', // Optionnel: Si vous voulez une largeur minimale pour le conteneur
                      }}>
            <Table>
              <TableHead>
                <TableRow sx={{  height: 32, minHeight: 32, size:"small",  }}>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor: "#107C41", fontWeight:"bold"}}>Code </TableCell>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor:" #107C41", fontWeight:"bold"}}>Indice client</TableCell>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor:" #107C41", fontWeight:"bold"}}>Nom client</TableCell>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor:" #107C41", fontWeight:"bold"}}>Type BDC</TableCell>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Fréquence</TableCell>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Durée</TableCell>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Montant</TableCell>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Taux interêt</TableCell>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Montant interet</TableCell>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Taux taxe</TableCell>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Monatnt taxe</TableCell>
                {/* <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Date début</TableCell>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Date fin</TableCell> */}
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Crée le</TableCell>
                  <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Crée par</TableCell>
                  {/* <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Status</TableCell> */}
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Actions</TableCell>
              </TableRow>
              </TableHead>
              <TableBody>
                   {paginatedDataBranch.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={10} align="center">Aucune entrée de code trouvée.</TableCell>
                      </TableRow>
                    ) : (
                      paginatedDataBranch.map((item,index) => (
                        <TableRow   key={`${item.CODSIMUL}-${item.NUMCLI}-${item.CODAGE}`}  sx={{
                          cursor: 'pointer',
                          backgroundColor: index % 2 === 0 ? '#f5f5f5' : '#ffffff',
                          '&:hover': {
                          // backgroundColor: '#e0f7fa', // Couleur au survol
                          // background: `linear-gradient(90deg, #1c3adc 0%, #365eff 100%)`,
                          //color: '#fff', // Texte blanc sur fond sombre
                          background: 'linear-gradient(90deg, #eaf3ff 0%, #dceeff 100%)',
                            },
                                  }} > 
                          {/* Clé unique pour React */}
                          <TableCell sx={{ py: 0 }}>{item.NUMBDC}</TableCell>
                          <TableCell sx={{ py: 0 }}>{item.NUMCLI}</TableCell>
                          <TableCell sx={{ py: 0 }}>{item.NOMCLI}</TableCell>
                          <TableCell sx={{ py: 0 }}>{item.TYPBDC}</TableCell>
                          <TableCell sx={{ py: 0 }}>{item.FREQPROV}</TableCell>
                          <TableCell sx={{ py: 0,textAlign: 'right' }}>{(item.DUREE)}</TableCell>
                          <TableCell sx={{ py: 0,textAlign: 'right' }}>{formatNumber(Number(item.MONTANT))}</TableCell>
                          <TableCell sx={{ py: 0 ,textAlign: 'right'}}>{ (item.TXINT)}</TableCell>
                          <TableCell sx={{ py: 0,textAlign: 'right' }}>{formatNumber(Number(item.MTNINT))}</TableCell>
                          <TableCell sx={{ py: 0,textAlign: 'right' }}>{(item.TXTAXE)}</TableCell>
                          <TableCell sx={{ py: 0,textAlign: 'right' }}>{formatNumber(Number(item.MTNTAXE))}</TableCell>
                          {/* <TableCell sx={{ py: 0 }}> {item.DATDEBUT ? new Date(item.DATDEBUT).toLocaleDateString() : 'N/A'}</TableCell>
                          <TableCell sx={{ py: 0 }}> {item.DATFIN ? new Date(item.DATFIN).toLocaleDateString() : 'N/A'}</TableCell> */}
                          <TableCell sx={{ py: 0 }}> {item.DATCRE ? new Date(item.DATCRE).toLocaleDateString() : 'N/A'}</TableCell>
                          <TableCell sx={{ py: 0 }}>{item.UTISAI ?? 'N/A'}</TableCell>
                          {/* <TableCell sx={{ py: 0 }}>{item.CDETAT ?? 'N/A'}</TableCell> */}
                          
                          <TableCell sx={{ py: 0 }}>
                           
                            <IconButton color="success" onClick={() =>calculer(item)}>
                              <ListIcon />
                            </IconButton>
                             <IconButton color="primary" onClick={() => { handleEdit(item); }}>
                              <EditIcon />
                            </IconButton>
                            <IconButton color="error" onClick={() =>handleDelete(item.IDBDC)}>
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
               
              </TableBody>
            </Table>

          </TableContainer>

          {/* Pagination */}
          <TablePagination
                component="div"
                count={filteredDataBranch.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 25, 50]}
                labelRowsPerPage="Lignes par page"
            />
        </Box>
      )}

      {tab === 1 && (
        <Box  mb={2} fontStyle="inherit" className='border'
          component="form"
          onSubmit={handleSubmit(onSubmit)}
          sx={{p:1,borderRadius: 3, background:'white'}}
         
        //   sx={{ display: "grid", gap: 2}}
        >
             <Grid container spacing={2} mb={2} >
                <Grid item xs={4}> 
                       <TextField 
                       label="Code opération" 
                      
                       size="small"
                       variant="outlined"
                       disabled={true}
                       //margin="dense"
                      //  InputLabelProps={{ shrink: true }}
                       fullWidth {...register("CODOPE")} //required  
                      sx={{
                            borderRadius: 10,
                            "& .MuiInputLabel-root": {
                              fontWeight: "bold",
                              fontSize: "16px",
                            },
                            "& .MuiOutlinedInput-root legend": {
                              maxWidth: 0,
                            }
                          }}
                       />
                    </Grid>     
                <Grid item xs={8}> 
                       <TextField 
                       label="Libelle opération" 
                      
                       size="small"
                       variant="outlined"
                       disabled={false}
                       //margin="dense"
                      //  InputLabelProps={{ shrink: true }}
                       fullWidth {...register("LIBOPE")} required  
                      sx={{
                            borderRadius: 10,
                            "& .MuiInputLabel-root": {
                              fontWeight: "bold",
                              fontSize: "16px",
                            },
                            "& .MuiOutlinedInput-root legend": {
                              maxWidth: 0,
                            }
                          }}
                       />
                    </Grid>        
             </Grid>
              <Grid container spacing={2} mb={2} >
                  <Grid item xs={2}> 
                   <TextField label="Reference BDC" size="small" 
                    disabled={!activ}
                   fullWidth {...register("REFBDC")} required  
                  // InputLabelProps={{ shrink: true }} 
                   sx={{
                            borderRadius: 10,
                            "& .MuiInputLabel-root": {
                              fontWeight: "bold",
                              fontSize: "16px",
                            },
                            "& .MuiOutlinedInput-root legend": {
                              maxWidth: 0,
                            }
                          }}
                            InputLabelProps={{ shrink: watch("REFBDC") ? true : false }} 
                   />
                  </Grid>
                    <Grid item xs={2}> 
                        <TextField 
                        label="Numero BDC" 
                        
                        size="small"
                        variant="outlined"
                        disabled={true}
                        //margin="dense"
                        //  InputLabelProps={{ shrink: true }}
                        fullWidth {...register("NUMBDC")} //required  
                        sx={{
                                borderRadius: 10,
                                "& .MuiInputLabel-root": {
                                fontWeight: "bold",
                                fontSize: "16px",
                                },
                                "& .MuiOutlinedInput-root legend": {
                                maxWidth: 0,
                                }
                            }}
                        />
                  </Grid>     
                  
                    <Grid item xs={2}>
                    <Controller
                            
                                name="CODSIMUL"
                                disabled={true}
                                control={control}
                                rules={{ required: true }}
                                render={({ field: { onChange, value } }) => (
                                <Autocomplete
                                    fullWidth
                                    options={simulations}
                                    disabled={true}
                                        // --- Texte affiché dans le menu ---
                                    getOptionLabel={(option) =>
                                        option ? `[${option.CODSIMUL}] - [${option.NOMCLI}]` : ""
                                    }
                                    // --- Recherche automatique MUI ---
                                    filterOptions={(options, state) =>
                                        options.filter(
                                        (o) =>
                                            o.CODSIMUL.toLowerCase().includes(state.inputValue.toLowerCase()) ||
                                            o.NOMCLI.toLowerCase().includes(state.inputValue.toLowerCase())
                                        )
                                    }
                                    value={simulations.find(s => s.CODSIMUL === value) || null}
                                    onChange={(e, selected) => {
                                        if (selected) {
                                        
                                        onChange(selected.CODSIMUL);
                                        

                                        // 👉 Remplissage automatique des autres champs
                                        setValue("NUMCLI", selected.NUMCLI,{ shouldDirty: true });
                                        setValue("NOMCLI", selected.NOMCLI,{ shouldDirty: true });
                                        setValue("TYPBDC", selected.TYPBDC,{ shouldDirty: true });
                                        setValue("TYPIMPUTINT", selected.TYPIMPUTINT,{ shouldDirty: true });
                                        setValue("FREQPROV", selected.FREQPROV,{ shouldDirty: true });
                                        setValue("DUREE", selected.DUREE,{ shouldDirty: true });
                                        setValue("DATDEBUT", formatDate(selected.DATDEBUT)  ,{ shouldDirty: true });
                                        setValue("DATFIN", formatDate (selected.DATFIN),{ shouldDirty: true });
                                        setValue("MONTANT", (selected.MONTANT ||0) ,{ shouldDirty: true });
                                        setValue("TXINT", selected.TXINT ||0,{ shouldDirty: true });
                                        setValue("MTNINT", selected.MTNINT ||0,{ shouldDirty: true });
                                        setValue("TXTAXE", selected.TXTAXE ||0,{ shouldDirty: true });
                                        setValue("MTNTAXE", selected.MTNTAXE ||0 ,{ shouldDirty: true });
                                        setValue("MTNNETAPAYER",  (selected.MTNNETAPAYER||0),{ shouldDirty: true });
                                        setValue("MTNPROVFREQ",  (selected.MTNPROVFREQ||0),{ shouldDirty: true });
                                        setValue("MTNTAXEFREQ",  (selected.MTNTAXEFREQ||0),{ shouldDirty: true });
                                        getComptes(selected.NUMCLI)
                                        } else {
                                        onChange("");
                                        setCompte([])
                                        }
                                    }}
                                    renderInput={(params) => (
                                        <TextField  {...params} 
                                        label="Code simulation"   size="small" required 
                                        disabled={!activ}
                                        sx={{
                                            borderRadius: 10,
                                            "& .MuiInputLabel-root": {
                                                fontWeight: "bold",
                                                fontSize: "16px",
                                            },
                                            "& .MuiOutlinedInput-root legend": {
                                                maxWidth: 0,
                                            }
                                            }}
                                        />
                                    )}
                                    />
                                )}
                                />
                                {/* <TextField label="Code simulation" fullWidth {...register("CODSIMUL")} required /> */}
                    </Grid>
                                
                    
                    <Grid item xs={3}>
                        <TextField 
                        label="Indice client" size="small" 
                        disabled={true}
                        fullWidth {...register("NUMCLI")}  
                          sx={{
                              borderRadius: 10,
                              "& .MuiInputLabel-root": {
                                fontWeight: "bold",
                                fontSize: "16px",
                              },
                              "& .MuiOutlinedInput-root legend": {
                                maxWidth: 0,
                              }
                            }}
                            InputLabelProps={{ shrink: watch("NUMCLI") ? true : false }}
                        //InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField 
                        label="Nom Client" size="small" 
                         disabled={true}
                        fullWidth {...register("NOMCLI")}  
                        //InputLabelProps={{ shrink: true }}
                          sx={{
                              borderRadius: 10,
                              "& .MuiInputLabel-root": {
                                fontWeight: "bold",
                                fontSize: "16px",
                              },
                              "& .MuiOutlinedInput-root legend": {
                                maxWidth: 0,
                              }
                            }}
                              InputLabelProps={{ shrink: watch("NOMCLI") ? true : false }}
                        />
                    </Grid>
              </Grid>

                <Grid container spacing={2} mb={2}>
                     <Grid item xs={1.5}>
                            <TextField label="Date debut" size="small" type="date" 
                             disabled={true}
                            fullWidth {...register("DATDEBUT")}  
                            //InputLabelProps={{ shrink: true }}
                              sx={{
                                borderRadius: 10,
                                "& .MuiInputLabel-root": {
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                },
                                "& .MuiOutlinedInput-root legend": {
                                  maxWidth: 0,
                                }
                              }}
                               
                                InputLabelProps={{ shrink: watch("DATDEBUT") ? true : false }}
                            />
                      </Grid>
                      <Grid item xs={1.5}>
                            <TextField label="Date fin" size="small" type="date" 
                             disabled={true}
                            fullWidth {...register("DATFIN")}  
                            // InputLabelProps={{ shrink: true }}
                            sx={{
                                borderRadius: 10,
                                "& .MuiInputLabel-root": {
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                },
                                "& .MuiOutlinedInput-root legend": {
                                  maxWidth: 0,
                                }
                              }}
                              InputLabelProps={{ shrink: watch("DATFIN") ? true : false }}
                            />
                      </Grid>
                    <Grid item xs={1.5}>
                          <TextField 
                          label="Type de bon" size="small" 
                           disabled={true}
                          fullWidth {...register("TYPBDC")} required  
                          //InputLabelProps={{ shrink: true }}
                          sx={{
                              borderRadius: 10,
                              "& .MuiInputLabel-root": {
                                fontWeight: "bold",
                                fontSize: "16px",
                              },
                              "& .MuiOutlinedInput-root legend": {
                                maxWidth: 0,
                              }
                            }}

                           InputLabelProps={{ shrink: watch("TYPBDC") ? true : false }}  
                          />
                    </Grid>
                    <Grid item xs={1.5}>
                          <TextField 
                          label="Type imputation" size="small" 
                           disabled={true}
                          fullWidth {...register("TYPIMPUTINT")} required  
                          //InputLabelProps={{ shrink: true }}
                          sx={{
                              borderRadius: 10,
                              "& .MuiInputLabel-root": {
                                fontWeight: "bold",
                                fontSize: "16px",
                              },
                              "& .MuiOutlinedInput-root legend": {
                                maxWidth: 0,
                              }
                            }}
                             InputLabelProps={{ shrink: watch("TYPIMPUTINT") ? true : false }}  
                          />
                    </Grid>
                    <Grid item xs={3}>
                          <TextField 
                          label="Freauence imputation" size="small" type="text" 
                           disabled={true}
                          fullWidth {...register("FREQPROV")} 
                          //InputLabelProps={{ shrink: true }}
                            sx={{
                              borderRadius: 10,
                              "& .MuiInputLabel-root": {
                                fontWeight: "bold",
                                fontSize: "16px",
                              },
                              "& .MuiOutlinedInput-root legend": {
                                maxWidth: 0,
                              }
                            }}
                             InputLabelProps={{ shrink: watch("FREQPROV") ? true : false }}  
                            />
                    </Grid>
                    <Grid item xs={3}>
                          <TextField label="Durée " size="small" type="number" 
                           disabled={true}
                          fullWidth {...register("DUREE")}  
                          //InputLabelProps={{ shrink: true }} 
                            InputProps={{
                          inputProps: {
                          style: { textAlign: "right" }
                              }
                              }}
                                sx={{
                              borderRadius: 10,
                              "& .MuiInputLabel-root": {
                                fontWeight: "bold",
                                fontSize: "16px",
                              },
                              "& .MuiOutlinedInput-root legend": {
                                maxWidth: 0,
                              }
                            }}
                              InputLabelProps={{ shrink: watch("DUREE") ? true : false }}
                          />
                    </Grid>
                </Grid>
               

                <Grid container spacing={2} mb={2}>
                  <Grid item xs={1.5}>
                            <TextField label="Montant" size="small" type="number" 
                             disabled={true}
                            fullWidth {...register("MONTANT")} 
                            // InputLabelProps={{ shrink: true }} 
                              InputProps={{
                            inputProps: {
                            style: { textAlign: "right" }
                                }
                                }}

                                  sx={{
                                borderRadius: 10,
                                "& .MuiInputLabel-root": {
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                },
                                "& .MuiOutlinedInput-root legend": {
                                  maxWidth: 0,
                                }
                              }}
                            InputLabelProps={{ shrink: watch("MONTANT") ? true : false }} 
                            />
                      </Grid>
                      
                      <Grid item xs={1.5}>
                            <TextField label="Taux Intérêt" size="small" type="number" 
                             disabled={true}
                            fullWidth {...register("TXINT")}  
                            //InputLabelProps={{ shrink: true }} 
                              InputProps={{
                             inputProps: { step: "0.001", min: 0 },
                            style: { textAlign: "right" }
                              
                                }}
                                  sx={{
                                borderRadius: 10,
                                "& .MuiInputLabel-root": {
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                },
                                "& .MuiOutlinedInput-root legend": {
                                  maxWidth: 0,
                                }
                              }}
                                InputLabelProps={{ shrink: watch("TXINT") ? true : false }} 
                            />
                      </Grid>

                      <Grid item xs={1.5}>
                            <TextField label="Taux taxe" size="small" type="number" 
                             disabled={true}
                            fullWidth {...register("TXTAXE")} 
                            // InputLabelProps={{ shrink: true }} 
                            InputProps={{
                            inputProps: { step: "0.001", min: 0 },
                            style: { textAlign: "right" }
                            
                               
                                }}
                                  sx={{
                                borderRadius: 10,
                                "& .MuiInputLabel-root": {
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                },
                                "& .MuiOutlinedInput-root legend": {
                                  maxWidth: 0,
                                }
                              }}
                               InputLabelProps={{ shrink: watch("TXTAXE") ? true : false }} 
                            />
                      </Grid>
                      <Grid item xs={1.5}>
                            <TextField label="Montant Intérêt" size="small" type="number" 
                             disabled={true}
                            fullWidth {...register("MTNINT")}  
                            //InputLabelProps={{ shrink: true }} 
                              InputProps={{
                            inputProps: {
                            style: { textAlign: "right" }
                                }
                                }}
                                  sx={{
                                borderRadius: 10,
                                "& .MuiInputLabel-root": {
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                },
                                "& .MuiOutlinedInput-root legend": {
                                  maxWidth: 0,
                                }
                              }}
                                InputLabelProps={{ shrink: watch("MTNINT") ? true : false }} 
                            />
                      </Grid>

                      
                      <Grid item xs={1.5}>
                            <TextField label="Montant taxe" size="small" type="number" 
                             disabled={true}
                            fullWidth {...register("MTNTAXE")}  
                            //InputLabelProps={{ shrink: true }}
                              InputProps={{
                            inputProps: {
                            style: { textAlign: "right" }
                                }
                                }}
                                  sx={{
                                borderRadius: 10,
                                "& .MuiInputLabel-root": {
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                },
                                "& .MuiOutlinedInput-root legend": {
                                  maxWidth: 0,
                                }
                              }}
                                 InputLabelProps={{ shrink: watch("MTNTAXE") ? true : false }} 
                            />
                      </Grid>
                      <Grid item xs={1.5}>
                            <TextField label="Montant à payer" size="small" type="number" 
                             disabled={true}
                            fullWidth {...register("MTNNETAPAYER")}  
                            //InputLabelProps={{ shrink: true }} 
                            InputProps={{
                            inputProps: {
                            style: { textAlign: "right" }
                                }
                                }}
                                  sx={{
                                borderRadius: 10,
                                "& .MuiInputLabel-root": {
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                },
                                "& .MuiOutlinedInput-root legend": {
                                  maxWidth: 0,
                                }
                              }}

                                InputLabelProps={{ shrink: watch("MTNNETAPAYER") ? true : false }} 
                            />
                      </Grid>
                      <Grid item xs={1.5}>
                          <TextField label="Montant provision" size="small" type="number" 
                           disabled={true}
                          fullWidth {...register("MTNPROVFREQ")}  
                          //InputLabelProps={{ shrink: true }} 
                          InputProps={{
                          inputProps: {
                          style: { textAlign: "right" }
                              }
                              }}
                                sx={{
                              borderRadius: 10,
                              "& .MuiInputLabel-root": {
                                fontWeight: "bold",
                                fontSize: "16px",
                              },
                              "& .MuiOutlinedInput-root legend": {
                                maxWidth: 0,
                              }
                            }}
                                  InputLabelProps={{ shrink: watch("MTNPROVFREQ") ? true : false }} 
                          />
                    </Grid>
                    <Grid item xs={1.5}>
                          <TextField label="Taxe/Provison" size="small" type="number" 
                           disabled={true}
                          fullWidth {...register("MTNTAXEFREQ")}  
                          //InputLabelProps={{ shrink: true }} 
                          InputProps={{
                          inputProps: {
                          style: { textAlign: "right" }
                              }
                              }}
                                sx={{
                              borderRadius: 10,
                              "& .MuiInputLabel-root": {
                                fontWeight: "bold",
                                fontSize: "16px",
                              },
                              "& .MuiOutlinedInput-root legend": {
                                maxWidth: 0,
                              }
                            }}
                                InputLabelProps={{ shrink: watch("MTNTAXEFREQ") ? true : false }} 
                          />
                    </Grid>
                </Grid>
               
               <Grid container spacing={2} mb={2}>
                   <Grid item xs={1.5}>
                            <TextField label="Date intéruption" size="small" type="date" 
                             //disabled={true}
                            fullWidth {...register("DATINTERUP")}  
                            // InputLabelProps={{ shrink: true }}
                            sx={{
                                borderRadius: 10,
                                "& .MuiInputLabel-root": {
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                },
                                "& .MuiOutlinedInput-root legend": {
                                  maxWidth: 0,
                                }
                              }}
                              //InputLabelProps={{ shrink: watch("DATINTERUP") ? true : false }}
                              onChange={(e) => {
                                getTauxPenalite(watch("TYPBDC"));
                                calculInterruptionBDC(jrRest);
                                }
                                
                               }
                                
                               onBlur={() => {
                                getTauxPenalite(watch("TYPBDC"));
                                calculInterruptionBDC(jrRest)}}
                            />
                      </Grid>

                      <Grid item xs={1.5}>
                            <TextField label="Jour restant" size="small" type="text" 
                             //disabled={true}
                            fullWidth {...register("JOURRESTANT")}  
                            // InputLabelProps={{ shrink: true }}
                            sx={{
                                borderRadius: 10,
                                "& .MuiInputLabel-root": {
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                },
                                "& .MuiOutlinedInput-root legend": {
                                  maxWidth: 0,
                                }
                              }}
                             // InputLabelProps={{ shrink: watch("JOURRESTANT") ? true : false }}
                               value={jrRest}
                               onChange={(e) => setJrRest(Number(e.target.value) )}
                              
                               onBlur={() => {
                               // getTauxPenalite(watch("TYPBDC"));
                                calculInterruptionBDC(jrRest)}}
                             InputLabelProps={{ shrink: watch("JOURRESTANT") ? true : false }}
                            />
                      </Grid>
                      <Grid item xs={1.5}>
                            <TextField label="penalite" size="small" type="number" 
                             //disabled={true}
                            fullWidth {...register("PENALITE")}  
                            // InputLabelProps={{ shrink: true }}
                            sx={{
                                borderRadius: 10,
                                "& .MuiInputLabel-root": {
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                },
                                "& .MuiOutlinedInput-root legend": {
                                  maxWidth: 0,
                                }
                              }}
                              //InputLabelProps={{ shrink: watch("PENALITE") ? true : false }}
                              value={montPenal}
                               onChange={(e) => setMontPenal(Number(e.target.value) )}
                            />
                      </Grid>

                       <Grid item xs={1.5}>
                            <TextField label="Interets acquis" size="small" type="number" 
                             disabled={true}
                            fullWidth {...register("INTACQUIS")}  
                            // InputLabelProps={{ shrink: true }}
                            sx={{
                                borderRadius: 10,
                                "& .MuiInputLabel-root": {
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                },
                                "& .MuiOutlinedInput-root legend": {
                                  maxWidth: 0,
                                }
                              }}
                              //InputLabelProps={{ shrink: watch("PENALITE") ? true : false }}
                             // value={montPenal}
                             value={intAquis}
                              onChange={(e) => setIntAquis(Number(e.target.value) )}
                            />
                      </Grid>

                      <Grid item xs={1.5}>
                            <TextField label="Interets du" size="small" type="number" 
                             disabled={true}
                            fullWidth {...register("INTDUS")}  
                            // InputLabelProps={{ shrink: true }}
                            sx={{
                                borderRadius: 10,
                                "& .MuiInputLabel-root": {
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                },
                                "& .MuiOutlinedInput-root legend": {
                                  maxWidth: 0,
                                }
                              }}
                              value={intDu}
                             //defaultValue={intDu}
                             // onChange={(e) => setIntDu(Number(e.target.value) )}
                              //InputLabelProps={{ shrink: watch("PENALITE") ? true : false }}
                             // value={montPenal}
                            />
                      </Grid>
               </Grid>
                
               
                
          <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
            <Button  disabled={!activ} variant="contained"  color="primary"  type="submit" 
             startIcon={selected ? <CheckCircleIcon /> : <CheckCircleIcon />} 
                sx={{ borderRadius: 2, fontWeight: 'bold' }}>
              {selected ? "Anticiper" : "Anticiper"}
              
            </Button>

             {/* <Button  disabled={!activ} variant="contained"  color="primary"   
             startIcon={selected ? <BlockIcon /> : <BlockIcon />} 
                sx={{ borderRadius: 2, fontWeight: 'bold' }}>
              {selected ? "Rejeter" : "Rejeter"}
              
            </Button> */}
            <Button variant="contained"  color="primary" onClick={() => { setTab(0); viderFormulaire();setActiv(false)} }
             startIcon={<CancelIcon />}
              sx={{ borderRadius: 2, fontWeight: 'bold' }}>
              Annuler
            </Button>
          </Box>
        </Box>
      )}

      <Dialog
  open={openDialog}
  onClose={() => setOpenDialog(false)}
  maxWidth="lg"
  fullWidth
>
  <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" ,backgroundColor: "#107C41",
    color: "white", }}
  >Tableau imputation des interets {selected?.NUMBDC+"-"+selected?.NOMCLI}
   <IconButton onClick={() => setOpenDialog(false)} size="small">
    <CloseIcon />
  </IconButton>
  </DialogTitle>

  <DialogContent sx={{ minHeight: 300 }}>

    {/* Résumé */}
    {echeancier && (
      <Box
  sx={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mt: 2,
    mb: 2,
    px: 1,
  }}
>
  {/* 🔹 Infos sur une ligne */}
  <Box sx={{ display: "flex", gap: 3 }}>
    <p>
      <b>Intérêt brut :</b>{" "}
      {Intl.NumberFormat("fr-FR", { minimumFractionDigits: 2 }).format(resultat.montInt)}
    </p>

    <p>
      <b>Taxe :</b>{" "}
      {Intl.NumberFormat("fr-FR", { minimumFractionDigits: 2 }).format(resultat.montTaxe)}
    </p>

    <p>
      <b>Net à percevoir :</b>{" "}
      {Intl.NumberFormat("fr-FR", { minimumFractionDigits: 2 }).format(resultat.montNet)}
    </p>
  </Box>

  {/* 🔹 Bouton exportation */}
  <Button
    variant="contained"
    color="success"
    startIcon={<GetAppIcon />}
    onClick={handleClickExportInt}
    sx={{ borderRadius: 2, fontWeight: "bold" }}
  >
    Exporter
  </Button>
   {/* Menu pour les formats d'exportation */}
            <Menu
              anchorEl={anchorElInt}
              // open={open1}
               open={Boolean(anchorElInt)}    // ouvert si anchorEl != null
              onClose={handleCloseExportInt}
               anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
          
              PaperProps={{
                sx: {
                  borderRadius: 3,
                  mt: 1,
                  minWidth: 180,
                },
              }}
               
            >
              <MenuItem onClick={() => handleExportInt('excel')}>
                <ListItemIcon><TableChartIcon color="primary" /></ListItemIcon>
                <ListItemText>Excel (.xlsx)</ListItemText>
              </MenuItem>
              <MenuItem onClick={() => handleExportInt('pdf')}>
                <ListItemIcon><PictureAsPdfIcon color="error" /></ListItemIcon>
                <ListItemText>PDF (.pdf)</ListItemText>
              </MenuItem>
              <MenuItem onClick={() => handleExportInt('word')}>
               <DescriptionIcon sx={{ color: "#2B579A" }} /> {/* Bleu Word */}
                <ListItemText>Word (.docx)</ListItemText>
              </MenuItem>
              <MenuItem onClick={() => handleExportInt('csv')}>
                <ListItemIcon><ArticleIcon color="info" /></ListItemIcon>
                <ListItemText>CSV (.csv)</ListItemText>
              </MenuItem>
              <MenuItem onClick={() => handleExportInt('json')}>
                <ListItemIcon><DescriptionIcon color="secondary" /></ListItemIcon>
                <ListItemText>JSON (.json)</ListItemText>
              </MenuItem>
            </Menu>
</Box>

      // <Box sx={{ p: 2, mb: 3, background: "#f7f7f7", borderRadius: 2 }}>
      //   <p><b>Intérêt brut :</b> { resultat.montInt.toFixed(2)}</p>
      //   <p><b>Taxe :</b> {resultat.montTaxe.toFixed(2)}</p>
      //   <p><b>Net à percevoir :</b> {resultat.montNet.toFixed(2)}</p>
      // </Box>
    )}

    {/* Tableau des échéances */}
    {echeancier && (
      // <Box sx={{ maxHeight: 350, overflow: "auto" }}>
      //   <table
      //     style={{
      //       width: "100%",
      //       borderCollapse: "collapse",
      //       fontSize: "14px",
      //     }}
      //   >
      //     <thead>
      //       <tr style={{ background: "#eef" }}>
      //         <th>Période</th>
      //         <th>Date imput</th>
      //         <th>Intérêt</th>
      //         <th>Taxe</th>
      //         <th>Net à payer</th>
      //       </tr>
      //     </thead>
      //     <tbody>
      //       {resultat.echeancier.map((e: any, idx: number) => (
      //         <tr key={idx}>
      //           <td>{e.periode}</td>
      //           <td>{e.dateImput}</td>
      //           <td>{e.interet.toFixed(2)}</td>
      //           <td>{e.taxe.toFixed(2)}</td>
      //           <td>{e.netAPayer.toFixed(2)}</td>
      //         </tr>
      //       ))}
      //     </tbody>
      //   </table>
      // </Box>
      <Box mb={1} fontStyle="inherit" className='border' sx={{p:1}}>
        <Grid item xs={12}>
        <TableContainer component={Paper} sx={{ mt: 2 }}>
          <Table size="small">
          <TableHead>
            <TableRow sx={{  height: 32, minHeight: 32, size:"small",  }}>
              <TableCell sx={{ color: '#fff', py: 1,backgroundColor: "#107C41", fontWeight:"bold"}}>Période</TableCell>
              <TableCell sx={{ color: '#fff', py: 1,backgroundColor: "#107C41", fontWeight:"bold"}}>Date imputation</TableCell>
           
              <TableCell sx={{ color: '#fff', py: 1,backgroundColor: "#107C41", fontWeight:"bold"}} align="right">Intérêt</TableCell>
              <TableCell sx={{ color: '#fff', py: 1,backgroundColor: "#107C41", fontWeight:"bold"}} align="right">Taxe</TableCell>
              <TableCell sx={{ color: '#fff', py: 1,backgroundColor: "#107C41", fontWeight:"bold"}} align="right">Net à payer</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {echeancier.map((row:any,index:number) => (
              <TableRow key={row.periode} sx={{
                                            cursor: 'pointer',
                                            backgroundColor: index % 2 === 0 ? '#f5f5f5' : '#ffffff',
                                             '&:hover': {
                                             // backgroundColor: '#e0f7fa', // Couleur au survol
                                             // background: `linear-gradient(90deg, #1c3adc 0%, #365eff 100%)`,
                                             //color: '#fff', // Texte blanc sur fond sombre
                                             background: 'linear-gradient(90deg, #eaf3ff 0%, #dceeff 100%)',
                                                 },
                                             }}>
                <TableCell>{row.periode}</TableCell>
                <TableCell>{row.dateImput}</TableCell>
                
                <TableCell align="right">{row.interet.toFixed(2)}</TableCell>
                <TableCell align="right">{row.taxe.toFixed(2)}</TableCell>
                <TableCell align="right">{row.netAPayer.toFixed(2)}</TableCell>
              </TableRow>
            ))}
          </TableBody>

          {/* Table Footer pour les totaux */}
    <TableFooter>
      <TableRow sx={{ backgroundColor: "#107C41", color: "#fff", fontWeight: "bold" }}>
        <TableCell colSpan={2} sx={{ color: '#fff', fontWeight: "bold" }}>Total</TableCell>
        <TableCell align="right" sx={{ color: '#fff', fontWeight: "bold" }}>{totalInteret.toFixed(2)}</TableCell>
        <TableCell align="right" sx={{ color: '#fff', fontWeight: "bold" }}>{totalTaxe.toFixed(2)}</TableCell>
        <TableCell align="right" sx={{ color: '#fff', fontWeight: "bold" }}>{totalNet.toFixed(2)}</TableCell>
      </TableRow>
    </TableFooter>
          </Table>
          </TableContainer>
        </Grid>     
      </Box>
    )}

  </DialogContent>
     </Dialog>

  </Box>
   
   
  );
}
